import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  TextField,
  InputAdornment,
  OutlinedInput,
  InputLabel,
  FormControl,
  styled,
  Menu,
  MenuItem,
} from "@mui/material";
import { useContext, useEffect, useMemo, useState } from "react";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AttachmentIcon from "@mui/icons-material/Attachment";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import styles from "./styles.module.css";
import ManualProcuracao from "./ManualProcuracao/index";
import { CadastroContext } from "../../../config/Context/CadastroContext";
import { LoginContext } from "../../../config/Context/LoginContext";
import { cadastroSimplesCliente } from "../../../services/api-upload.service";
import Loading from "../../../components/Loading";
import SnackBar from "../../../components/SnackBar";
import { useNavigate } from "react-router-dom";
import { NomeCompleto } from "../../../utils/localStorage.util";

const initialFormData = {
  certificadoDigital: null,
  senha: ".",
  procuracao: null,
  documentos: [],
  optionSelected: "procuracao",
};

const ModalArquivos = ({ open, onClose, tiposNegocio, onSuccess }) => {
  const { dados } = useContext(CadastroContext);
  const { dadosLogin } = useContext(LoginContext);
  const navigate = useNavigate();
  const [openManual, setOpenManual] = useState(false);
  const [showPassword, setShowPassword] = useState(true);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [formData, setFormData] = useState(initialFormData);
  const [optionArquive, setOptionArquive] = useState(formData.optionSelected);
  const [loading, setLoading] = useState(false);
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });

  useEffect(() => {
    setOptionArquive(formData.optionSelected);
  }, [formData.optionSelected]);

  const documentosPorServicos = {
    "Recuperação ICMS": [
      { key: "sped_fiscal_icms", name: "SPED Fiscal ICMS" },
      { key: "sped_contribuicoes_icms", name: "SPED Contribuições ICMS" },
      { key: "ecd_icms", name: "ECD ICMS" },
      { key: "xml_icms", name: "XMLs ICMS" },
    ],
    "Recuperação PIS/COFINS": [
      { key: "sped_fiscal_pisCofins", name: "SPED Fiscal PIS/COFINS" },
      {
        key: "sped_contribuicoes_pisCofins",
        name: "SPED Contribuições PIS/COFINS",
      },
      { key: "ecd_pisCofins", name: "ECD PIS/COFINS" },
      { key: "xml_pisCofins", name: "XMLs PIS/COFINS" },
    ],
    "Recuperação INSS": [
      { key: "folha_pagamento", name: "Resumo da folha de pagamento" },
      { key: "incidencia_verbas", name: "Relatório de incidência de verbas" },
      { key: "rubricas", name: "Rubricas da SEFIP" },
      { key: "cprb", name: "Informação sobre a CPRB" },
    ],
  };

  const preventDefault = (event) => event.preventDefault();

  const handleSnackBar = (obj) => {
    setObjSnackBar(obj);
  };

  const handleClose = () => {
    handleChangeService("procuracao");
    setShowPassword(true);
    onClose();
  };

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const handleFileUpload = (file, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: file,
      ...(fieldName === "certificadoDigital" && {
        procuracao: null,
        documentos: [],
        optionSelected: "certificado",
      }),
      ...(fieldName === "procuracao" && {
        certificadoDigital: null,
        documentos: [],
        optionSelected: "procuracao",
      }),
    }));
  };

  const handleDocumentosChange = (file, key) => {
    setFormData((prev) => {
      const updatedDocumentos = { ...prev.documentos, [key]: file };
      return {
        ...prev,
        documentos: updatedDocumentos,
        certificadoDigital: null,
        procuracao: null,
        optionSelected: "documentos",
      };
    });
  };

  const handleFile = (file, fieldName) => {
    if (
      file &&
      ((file.type === "application/pdf" && fieldName === "procuracao") ||
        (file.type === "application/x-pkcs12" &&
          fieldName === "certificadoDigital"))
    ) {
      handleFileUpload(file, fieldName);
    } else {
      alert("Por favor, anexe arquivos válidos");
    }
  };

  const handleChangeService = (service) => {
    setFormData({ ...initialFormData, optionSelected: service });
    setOptionArquive(service);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const body = {
        ...dados,
        cpf: dados.cpf ? dados.cpf.replace(/\D/g, "") : "",
        cnpj: dados.cnpj ? dados.cnpj.replace(/\D/g, "") : "",
        tipoCadastro: dadosLogin.tipoCadastroPlanTribKey,
      };

      const formDataToSend = new FormData();
      formDataToSend.append("cliente", JSON.stringify({ ...body }));

      if (formData.certificadoDigital) {
        formDataToSend.append(
          "arquivos[certificadoDigital]",
          formData.certificadoDigital
        );
        formDataToSend.append("arquivos[senha]", formData.senha);
        formDataToSend.append("arquivos[documento]", "false");
      } else if (formData.procuracao) {
        formDataToSend.append("arquivos[procuracao]", formData.procuracao);
        formDataToSend.append("arquivos[documento]", "false");
      } else if (formData.documentos) {
        const documentosObj =
          formData.documentos && typeof formData.documentos === "object"
            ? formData.documentos
            : {};

        Object.entries(documentosObj).forEach(([tipoServico, files]) => {
          if (Array.isArray(files)) {
            files.forEach((file) => {
              formDataToSend.append(
                `arquivos[documentos][${tipoServico}]`,
                file
              );
            });
          } else if (files) {
            formDataToSend.append(
              `arquivos[documentos][${tipoServico}]`,
              files
            );
          }
        });

        formDataToSend.append("arquivos[documento]", "true");
      }

      await cadastroSimplesCliente(formDataToSend);
      handleSnackBar({
        type: "success",
        msg: `Cliente cadastrado com sucesso.`,
      });
      handleClose();
      navigate("/dashboard?cadastro=true&cliente=true");
    } catch (error) {
      console.error("Erro ao enviar dados:", error);
      handleSnackBar({
        type: "error",
        msg: "Erro ao cadastrar cliente. Contate o suporte.",
      });
    } finally {
      setLoading(false);
    }
  };;

  const isFormValid = () => {
    switch (formData.optionSelected) {
      case "certificado":
        return (
          formData.certificadoDigital !== null &&
          formData.senha.trim() !== "" &&
          formData.senha.trim() !== "."
        );
      case "procuracao":
        return formData.procuracao !== null;
      case "documentos":
        const documentosObrigatorios =
          tiposNegocio?.flatMap((tipo) =>
            documentosPorServicos[tipo.descricao]?.map((doc) => doc.key)
          ) || [];
        return documentosObrigatorios.every((key) => formData.documentos[key]);
      default:
        return false;
    }
  };

  const InputFile = ({ inputKey, name }) => {
    return (
      <div style={{ display: "flex", gap: "0.5rem" }}>
        <TextField
          InputLabelProps={{ shrink: true }}
          size="small"
          label={name}
          fullWidth
          value={formData.documentos[inputKey]?.name || ""}
          InputProps={{ endAdornment: null }}
          disabled
        />
        <Button
          component="label"
          variant="contained"
          size="small"
          className={
            formData.documentos[inputKey]
              ? styles.botaoUploadOk
              : styles.botaoUpload
          }
        >
          {formData.documentos[inputKey] ? "Ok" : <UploadFileIcon />}
          <VisuallyHiddenInput
            type="file"
            onChange={(e) =>
              handleDocumentosChange(e.target.files[0], inputKey)
            }
          />
        </Button>
      </div>
    );
  };

  const UploadPdf = ({ text, fieldName, accept }) => {
    return (
      <div
        onDrop={(e) => {
          preventDefault(e);
          const file = e.dataTransfer.files[0];
          handleFile(file, fieldName);
        }}
        onDragOver={preventDefault}
        onDragEnter={preventDefault}
        className={styles.container_upload}
      >
        {formData[fieldName] ? (
          <>
            <AttachmentIcon sx={{ fontSize: "8rem" }} />
            <p>{formData[fieldName].name}</p>
            <p>Clique ou arraste um novo arquivo para trocar o selecionado</p>
          </>
        ) : (
          <>
            <UploadFileIcon sx={{ fontSize: "8rem" }} />
            <p style={{ textAlign: "center" }}>{text}</p>
          </>
        )}
        <input
          type="file"
          accept={accept}
          onChange={(e) => handleFile(e.target.files[0], fieldName)}
          className={styles.input}
        />
      </div>
    );
  };

  const renderCertificadoContent = () => (
    <>
      <h2>Vamos seguir então com seu certificado digital</h2>
      <p className={styles.paragrafo}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam
        fermentum sodales nisl in pharetra. Mauris et tincidunt nibh. Morbi mi
        nibh, gravida ut sagittis nec, porttitor eu odio. Sed dignissim eget
        elit vel efficitur. Duis at mauris congue, suscipit augue ac, convallis
        tellus. In id est condimentum orci aliquet tincidunt eu quis ligula. In
        egestas risus nec turpis suscipit, eget ultricies ante euismod. Nunc
        placerat lacus cursus tempor ultricies. Quisque dignissim orci vitae
        eleifend ultricies. Fusce dignissim metus non dapibus efficitur.
      </p>
      <div className={styles.senhaCertificado}>
        <FormControl variant="outlined">
          <InputLabel htmlFor="certificado">Senha do Certificado</InputLabel>
          <OutlinedInput
            value={formData.senha}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, senha: e.target.value }))
            }
            id="certificado"
            type={showPassword ? "text" : "password"}
            sx={{ width: "16rem" }}
            label="Senha do Certificado"
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </div>
      <UploadPdf
        accept=".pfx"
        text="Arraste e solte aqui o certificado ou clique para selecionar"
        fieldName="certificadoDigital"
      />
      <div className={styles.containerBtnCertificado}>
        <Button
          className={styles.btnProcuracao}
          onClick={() => handleChangeService("procuracao")}
        >
          Desejo enviar a procuração
        </Button>
        <Button
          className={styles.btnDiscreto}
          onClick={() => handleChangeService("documentos")}
        >
          <u>Não possuo ou não gostaria de enviar o certificado digital.</u>
        </Button>
      </div>
    </>
  );

  const renderProcuracaoContent = () => (
    <>
      <div>
        <h2>Procuração</h2>
        <p className={styles.paragrafo}>
          Recomendamos o envio da procuração. Ela é fundamental para que possamos
          agilizar e facilitar o acesso às informações da sua empresa, como notas
          fiscais, arquivos SPED e outras obrigações.
        </p>
        <p className={styles.paragrafo}>
          Além disso, com a procuração, você garante mais eficiência no processo
          e mantém total controle e segurança, já que pode limitar os acessos
          conforme desejar.
        </p>
        <p className={styles.paragrafo}>
          Caso precise de ajuda para geração da Procuração, clique abaixo para
          acessar o manual que criamos para você:
        </p>
        <br />
        <Button
          variant="outlined"
          onClick={() => setOpenManual(true)}
          className={styles.btnManual}
        >
          Manual de geração de Procuração
        </Button>
      </div>

      <div className={styles.senhaCertificado}></div>
      <UploadPdf
        accept="application/pdf"
        text="Arraste e solte aqui o pdf da procuração ou clique para selecionar"
        fieldName="procuracao"
      />
      <Button
        className={styles.btnDiscreto}
        onClick={() => handleChangeService("certificado")}
      >
        <u>Prefiro o envio do certificado digital ou os documentos isolados.</u>
      </Button>
    </>
  );

  const renderOutrosContent = (
    menuAnchorEl,
    handleMenuOpen,
    handleMenuClose
  ) => {
    const documentos =
      tiposNegocio?.flatMap(
        (tipo) => documentosPorServicos[tipo.descricao] || []
      ) || [];

    return (
      <>
        <h2>
          Para avançarmos, precisaremos então de todos os documentos abaixo
        </h2>
        <p style={{ margin: "1rem 0 2rem 0", textAlign: "center" }}>
          Cada item abaixo aceita apenas 1 arquivo. Caso tenha mais de um para
          enviar, por favor, compacte-os em um único arquivo.
        </p>
        <div className={styles.containerDocumento}>
          {documentos.map((doc, index) => (
            <div className={styles.documento} key={index}>
              <InputFile inputKey={doc.key} name={doc.name} />
            </div>
          ))}
        </div>
        <div className={styles.container_btn}>
          <Button
            id="basic-button"
            aria-controls={Boolean(menuAnchorEl) ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={Boolean(menuAnchorEl) ? "true" : undefined}
            onClick={handleMenuOpen}
            className={styles.btnProcuracao}
          >
            Desejo usar as opções anteriores
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={handleMenuClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem
              onClick={() => {
                handleChangeService("procuracao");
                handleMenuClose();
              }}
            >
              Desejo enviar a Procuração
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleChangeService("certificado");
                handleMenuClose();
              }}
            >
              Desejo enviar o Certificado Digital
            </MenuItem>
          </Menu>
        </div>
      </>
    );
  };

  const renderContent = () => {
    const handleMenuOpen = (event) => {
      setMenuAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
      setMenuAnchorEl(null);
    };
    switch (optionArquive) {
      case "certificado":
        return renderCertificadoContent();
      case "procuracao":
        return renderProcuracaoContent();
      case "documentos":
        return renderOutrosContent(
          menuAnchorEl,
          handleMenuOpen,
          handleMenuClose
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth={loading ? "sm" : "lg"}
        aria-haspopup="true"
      >
        <DialogContent>
          {loading ? (
            <Loading loading={loading} />
          ) : (
            <>
              {renderContent()}
              <DialogActions className={styles.container_btn}>
                <Button
                  className={styles.btn_close}
                  onClick={handleClose}
                  variant="outlined"
                >
                  Fechar
                </Button>
                <Button
                  className={isFormValid() ? styles.btn_avancar : ""}
                  variant="contained"
                  disabled={!isFormValid()}
                  onClick={handleSubmit}
                >
                  Enviar
                </Button>
              </DialogActions>
            </>
          )}
        </DialogContent>
      </Dialog>
      <ManualProcuracao
        open={openManual}
        onClose={() => setOpenManual(false)}
      />
      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={handleSnackBar} />
    </>
  );
};

export default ModalArquivos;
